// Dependencies
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/es/lib/isMobilePhone';

// JSON data
import countries from '../json/countries.json';
import states from '../json/states.json';

const enquiry = (formData) => {
  const firstName = formData?.firstName;
  const lastName = formData?.lastName;
  const email = formData?.email;
  const telephone = formData?.telephone;
  const country = formData?.country;
  const state = formData?.state;
  const event = formData?.event;

  const output = {
    errors: {},
    success: false,
  };

  if (!firstName || firstName === '')
    output.errors.firstName = 'Please enter your first name.';

  if (!lastName || lastName === '')
    output.errors.lastName = 'Please enter your last name.';

  if (!email || email === '')
    output.errors.email = 'Please enter your email address.';
  else if (!isEmail(email))
    output.errors.email = 'Please enter a valid email address.';

  if (!telephone || telephone === '')
    output.errors.telephone = 'Please enter your telephone number.';
  else if (!isMobilePhone(telephone))
    output.errors.telephone = 'Please enter a valid telephone number.';

  if (!event) {
    if (!country)
      output.errors.country = 'Please enter your country of residence.';
    else {
      const countriesResults = countries.filter((x) => x?.value === country);

      if (!countriesResults.length)
        output.errors.country = 'Please select a valid country.';

      if (state) {
        const statesResults = states.filter((x) => x?.value === state);

        if (!statesResults.length)
          output.errors.state = 'Please select a valid state.';
      }
    }
  }

  if (Object.keys(output?.errors).length === 0) {
    output.success = true;
  }

  return output;
};

export default enquiry;
